export default __webpack_public_path__ + "static/weareg58-mobile-3c466fea5044deca3a00b9a4175bee09.mp4";